import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

const TRANSITION_CONFIG = {
  type: 'tween',
  duration: 0.15,
};

interface SidebarSectionAnimationProps {
  sectionKey: string;
  expanded: boolean;
  children: React.ReactNode;
}

const SidebarSectionAnimation = ({
  sectionKey,
  expanded,
  children,
}: SidebarSectionAnimationProps) => (
  <AnimatePresence initial={false}>
    {expanded && (
      <motion.div
        key={sectionKey}
        initial={{ height: 0 }}
        animate={{
          height: 'auto',
          transition: { ...TRANSITION_CONFIG, ease: [1, 0, 1, 1] },
        }}
        exit={{
          height: 0,
          transition: { ...TRANSITION_CONFIG, ease: [0, 0, 0, 1] },
        }}
        style={{ overflow: 'hidden' }}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);

export default SidebarSectionAnimation;
